import { useParams } from 'react-router-dom';
import { useGetIsEmbedded } from 'automation-ui-permissions/feature-permissions/hooks/embedHooks';
import { useFeaturePermissionQueries } from 'automation-ui-permissions/feature-permissions/hooks/featurePermissionHooks';
import { getFeaturePermissionAndQuery } from 'automation-ui-permissions/feature-permissions/utils/featurePermissions';
import { jsx as _jsx } from "react/jsx-runtime";
export const withFeaturePermissions = WrappedComponent => props => {
  const {
    flowId
  } = useParams();
  const isEmbedded = useGetIsEmbedded();
  const {
    featurePermissionsQuery,
    featurePermissionsByFlowIdQuery,
    embedFeaturePermissionsQuery,
    loading,
    error
  } = useFeaturePermissionQueries({
    flowId,
    isEmbedded
  });
  return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
    featurePermissionsLoading: loading,
    featurePermissionsError: error,
    getFeaturePermission: ({
      sourceApp,
      feature,
      featureContext
    }) => {
      return getFeaturePermissionAndQuery(featurePermissionsQuery, featurePermissionsByFlowIdQuery, embedFeaturePermissionsQuery, flowId, isEmbedded, feature, sourceApp, featureContext);
    }
  }));
};